export const SCREEN_4K = 3840;
export const SCREEN_XL = 1200;
export const SCREEN_L = 992;
export const SCREEN_MD = 768;
